import styled from "@emotion/styled";
import { ArrowBack } from "@mui/icons-material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Box,
  Breadcrumbs,
  Chip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { IBreadcrumbProps } from "./IBreadcrumbProps";

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({
  subtitle,
  items,
  title,
  children,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box display={"flex"} sx={{ mt: 1, mb: 0.5, alignItems: "center" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "30px",
        }}
      >
        <ArrowBack
          color="action"
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          ml: 1,
        }}
      >
        {subtitle && (
          <Typography
            color="textSecondary"
            fontWeight="400"
            variant="h4"
            sx={{
              lineHeight: 1.2,
            }}
          >
            {subtitle}
          </Typography>
        )}

        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{
            "& .MuiBreadcrumbs-ol": {
              flexWrap: "nowrap",
            },
          }}
        >
          {items
            ? items.map((item) => (
                <div key={item.title}>
                  {item.to ? (
                    <StyledBreadcrumb
                      component={Link}
                      to={item.to}
                      label={item.title}
                      sx={{
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "none",
                        },
                      }}
                    />
                  ) : (
                    <Typography
                      color="textPrimary"
                      textTransform={"capitalize"}
                    >
                      {item.title}
                    </Typography>
                  )}
                </div>
              ))
            : ""}
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

const StyledBreadcrumb = styled(Chip)(({ theme }: any) => {
  return {
    backgroundColor: theme.palette.primary.main,
    height: theme.spacing(3),
    color: "#fff",
    mt: 3,
    fontWeight: theme.typography.fontWeightRegular,
    // textTransform: "capitalize",
  };
}) as typeof Chip;
